import React from 'react';
import Toast from 'react-bootstrap/Toast';
import { Variant } from '..';

export default function Notification({ autohide, delay, show, animation, title, message, type, onClose }) {

    if (!type)
        type = 'success';

    if (!autohide)
        autohide = true;

    if (!animation)
        animation = true;

    if (!delay)
        delay = 5000;

    const onNotifyClose = () => {
        if (onClose)
            onClose();
    };

    return (
        <div aria-live='polite' aria-atomic='true'>
            <div style={{
                position: 'absolute',
                top: '1em',
                right: '1em',
                zIndex: '9999',
                float: 'right'
            }}>

                <Toast
                    bg={type}
                    autohide={autohide}
                    animation={animation}
                    delay={delay}
                    show={show}
                    onClose={onNotifyClose}
                >
                    <Toast.Header>
                        <strong className='me-auto'>{title}</strong>
                    </Toast.Header>
                    <Toast.Body className={
                        (type === Variant.DARK || type === Variant.DANGER || type === Variant.SUCCESS) && 'text-white'
                    }>
                        {message}
                    </Toast.Body>
                </Toast>
            </div>
        </div>
    );
}